import { createApp } from "vue";
import App from "./App.vue";
import { router } from "./router/index.js";
import { verifyRestoredSession } from "./stores/session.js";

// The design system loads first so its tokens are available to everything.
import "./styles/design-system.css";
import "./styles/app.css";

// A restored token is only a claim until the API accepts it. Kick the check off
// before mounting so a forged value never renders a workspace.
verifyRestoredSession();

createApp(App).use(router).mount("#app");
